import { Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-leave-game-confirm-modal',
  templateUrl: './leave-game-confirm-modal.component.html',
  styleUrls: ['./leave-game-confirm-modal.component.scss'],
  standalone: false
})
export class LeaveGameConfirmModalComponent {
  constructor(public modalRef: MdbModalRef<LeaveGameConfirmModalComponent>) {}

  confirm(): void {
    this.modalRef.close(true);
  }

  cancel(): void {
    this.modalRef.close(false);
  }
}